import React from "react";
import PropTypes from "prop-types";
import MaterialTable from "material-table";
import { getTotalPriceStr, isDev } from "../../helpers";
import { Grid, Typography } from "@material-ui/core";
import { History } from "@material-ui/icons";

const columns = [
  { title: "ID", field: "id", editable: "never", sorting: false },
  { title: "Name", field: "name", editable: "never", sorting: false },
  {
    title: "Menge",
    field: "quantity",
    type: "numeric",
    sorting: false,
    width: 50,
  },
  {
    title: "Einzelpreis",
    field: "price",
    type: "currency",
    editable: "never",
    currencySetting: {
      currencyCode: "EUR",
      maximumFractionDigits: 2,
    },
    sorting: false,
    headerStyle: { textAlign: "right" },
    width: 90,
  },
];

export default function EditableTable(props) {
  const { orders, setOrders, deliverCost } = props;
  return (
    <Grid container direction="column">
      <Grid item>
        <MaterialTable
          columns={columns}
          data={orders}
          options={{
            search: false,
            tableLayout: "fixed",
            toolbar: false,
            rowStyle: { padding: 4 },
            paging: false,
            actionsCellStyle: { display: "none" },
          }}
          localization={{
            header: {
              actions: "Ändern",
            },
            body: {
              editRow: {
                deleteText: "Wollen Sie diese Reihe entfernen?",
              },
            },
          }}
          components={{ Container: (props) => <div {...props} /> }}
          editable={
            props.hiddenAction
              ? null
              : {
                  onRowUpdate: (newData, oldData) =>
                    new Promise((resolve) => {
                      setTimeout(() => {
                        resolve();
                        if (oldData) {
                          setOrders((prevOrders) => {
                            const data = [...prevOrders];
                            console.log(oldData, newData);
                            data[data.indexOf(oldData)] = newData;
                            console.log(data);
                            return data;
                          });
                        }
                      }, 600);
                    }),
                  onRowDelete: (oldData) =>
                    new Promise((resolve) => {
                      setTimeout(() => {
                        resolve();
                        setOrders((prevState) => {
                          const data = [...prevState];
                          data.splice(data.indexOf(oldData), 1);
                          return data;
                        });
                      }, 600);
                    }),
                }
          }
        />
      </Grid>
      <Grid item container justify="flex-end" direction="row">
        {isDev && (
          <Typography variant="inherit" display="block" gutterBottom>
            Lieferkosten: {deliverCost.toFixed(2)}
          </Typography>
        )}
      </Grid>
      <Grid item container justify="flex-end" direction="row">
        <Typography variant="overline" display="block" gutterBottom>
          Total:{" "}
          {isDev
            ? (Number(getTotalPriceStr(orders)) + deliverCost).toFixed(2)
            : getTotalPriceStr(orders)}
        </Typography>
      </Grid>
    </Grid>
  );
}

EditableTable.prototype = {
  data: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.string,
      name: PropTypes.string,
      quantity: PropTypes.number,
      price: PropTypes.number,
    })
  ),
};
